import React from 'react'
import styles from './styles.module.scss'
import { CategoryType } from '../product-list-section'
import { useTranslations } from 'next-intl'
import Link from 'next/link'
import SvgArrowRight from '@/src/assets/svgs/collection/arrow-right.svg'
import { CategoriesFunctions } from '../../functions'
import SvgSale from '@/src/assets/svgs/collection/sale.svg'
import { useMerchant } from '@/src/context/merchant/merchant-context'

interface Props {
    id: string
    title: string
    type: CategoryType
    showSeeAll?: boolean
    className?: string
}

export default function CategorySectionHeader(props: Props) {
    const { localMode } = useMerchant()

    const local = localMode ? '?localmode=on' : ''

    return (
        <div
            data-id={props.type === 'promotions' ? 'promo' : ''}
            className={`${styles.categoriesHeader} ${props.className ?? ""}`}
            id={props.type === 'promotions' ? CategoriesFunctions.formatStrToNavigation('section', 'promocoes') : ''}
        >
            <div className={styles.titleArea}>
                {
                    props.type === 'weeklyTop' || props.type === 'promotions' &&
                    <div className={styles.imageArea}>
                        {props.type === 'promotions' ? <SvgSale /> : <></>}
                    </div>
                }
                <h2 className={`${styles.title} font-lg`}>{props.title}</h2>
            </div>
            {
                props.showSeeAll !== false &&
                <Link href={props.type === 'promotions' ? `/promocoes${local}` : `/top-da-semana${local}`}>
                    <span className={styles.seeAll}>
                        {useTranslations('categories-navigation')('seeAll')} <SvgArrowRight className={styles.arrowRightIcon} />
                    </span>
                </Link>
            }
        </div>
    )
}
